import styles from './styles.module.scss'

export const TextWithBullet = ({children}:{children: React.ReactNode}) => {
  return (
    <div className={styles.textWithBullet}>
      <span>•</span>
      <div>
        {children}
      </div>
    </div>
  )
}
